import { PointUnitName } from "../../../models/pointRule";
import { DEFAULT_POINT_CURRENCY_NAME } from "../../../models/pointSettings";
import { useGetPointSettingsQuery } from "../../../store/services/point-settings";

/**
 * Cómo se llaman los puntos en la app del tenant elegido, para la vista previa "Así se ve en la
 * app". Mientras carga, o si no se puede leer la configuración, usa el nombre por defecto.
 */
export const useAppPointUnitName = (enabled: boolean): PointUnitName => {
  const { data: settings } = useGetPointSettingsQuery(undefined, { skip: !enabled });
  return settings?.effectiveCurrencyName ?? DEFAULT_POINT_CURRENCY_NAME;
};
